/* =====================================================================
   Superette × Fish Wishlist v2 — sharp images in the wishlist drawers (v1.0)
   ⚠ JavaScript. Never paste into the Fish Wishlist Custom CSS box.
   Fish asks Shopify for 350px thumbnails (collections 300px), which look soft once they're shown
   larger or on a retina screen. Every Shopify CDN image in the save drawer, lists drawer, toasts and
   Notify me sheet gets a srcset (400–1200px), so the browser loads the size the screen needs —
   the same quality as the product page.
   ===================================================================== */
(() => {
  const SCOPE = 'fw2-drawer img, atw-drawer img, .sp-recs img, [class*="sp-toast"] img, [class*="sp-notify"] img';
  const WIDTHS = [400, 600, 800, 1000, 1200];
  const isShopify = (u) => /\/cdn\/shop\/|cdn\.shopify\.com\/|\/s\/files\//.test(u);

  // base URL with Shopify's size suffix (_350x350, _300x, _x400, _crop_center, @2x) and width / height params removed
  const base = (u) => {
    const [path, query = ''] = u.split('?');
    const clean = path.replace(/_(\d+x\d*|\d*x\d+)(_crop_[a-z]+)?(@\dx)?(?=\.[a-z0-9]+$)/i, '');
    const params = query.split('&').filter((p) => p && !/^(width|height|crop)=/i.test(p));
    return { clean, params };
  };
  const at = (b, w) => `${b.clean}?${[...b.params, `width=${w}`].join('&')}`;

  const sharpen = (img) => {
    if (img.dataset.spSharp) return;
    const src = img.getAttribute('src') || '';
    if (!src || src.startsWith('data:') || !isShopify(src)) return;
    const b = base(src);
    img.dataset.spSharp = '1';
    img.srcset = WIDTHS.map((w) => `${at(b, w)} ${w}w`).join(', ');
    // the width it's shown at, so the browser picks the right file (×2 on retina happens automatically)
    const shown = Math.round(img.getBoundingClientRect().width || img.parentElement?.getBoundingClientRect().width || 0);
    img.sizes = shown > 40 ? `${shown}px` : '(max-width: 749px) 50vw, 320px';
    img.src = at(b, 800);
  };

  const run = (root) => {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SCOPE)) sharpen(root);
    root.querySelectorAll(SCOPE).forEach(sharpen);
  };

  // Fish redraws items (and swaps src) as lists open and change: re-check new images and changed src
  new MutationObserver((muts) => {
    muts.forEach((m) => {
      if (m.type === 'attributes') {
        const img = m.target;
        if (img.tagName === 'IMG' && img.dataset.spSharp && !(img.getAttribute('src') || '').includes('width=800')) {
          delete img.dataset.spSharp;
          img.removeAttribute('srcset');
          if (img.matches(SCOPE)) sharpen(img);
        }
        return;
      }
      m.addedNodes.forEach((n) => { if (n.nodeType === 1) run(n); });
    });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['src'] });

  // sizes depend on layout, which only exists once a drawer opens: refresh them then
  document.addEventListener('click', () => setTimeout(() => {
    document.querySelectorAll('img[data-sp-sharp]').forEach((img) => {
      const shown = Math.round(img.getBoundingClientRect().width);
      if (shown > 40) img.sizes = `${shown}px`;
    });
  }, 600), true);

  const init = () => run(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
